import { render, staticRenderFns } from "./OrderPicking.vue?vue&type=template&id=2432331b&scoped=true&"
import script from "./OrderPicking.vue?vue&type=script&lang=js&"
export * from "./OrderPicking.vue?vue&type=script&lang=js&"
import style0 from "./OrderPicking.vue?vue&type=style&index=0&id=2432331b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432331b",
  null
  
)

export default component.exports